import React, {FC} from 'react'
import TCol from './TCol'

type TRowProps = {
  columns: Array<{
    colIndex: number
    value: any
    type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action'
    rowIndex: number
    dataKey: string
    rowGuid: string
    content?: any
  }>
  rowType: 'data' | 'header'
  rowIndex: number
  onSort?: (crit: {Sort: string, Order: 'asc' | 'desc'}) => void;
  activeSort?: {Sort: string, Order: 'asc' | 'desc'}
}

const TRow: FC<TRowProps> = ({columns, rowType = 'data', rowIndex, activeSort, onSort}) => {
  return (
    <tr>
      {columns.map((r, i) => {
        return <TCol key={'CT_ROW_' + r.colIndex + r.rowGuid + i} data={r} rowType={rowType} onSort={onSort} activeSort={activeSort} />
      })}
    </tr>
  )
}

export default TRow
